var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPage1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3058 7.04457C13.3085 3.90927 10.9531 1.27363 7.83739 0.925225C4.72165 0.576817 1.8422 2.62701 1.15178 5.68518C0.461737 8.74372 2.18196 11.8316 5.14531 12.855V17.46H9.16179V12.8546C10.371 12.4374 11.42 11.6536 12.1628 10.6122C12.9055 9.5708 13.3051 8.32371 13.3058 7.04457V7.04457Z",
    stroke: "#FFC97A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.50977 14.5898H9.85817V16.6777H4.50977V14.5898Z",
    stroke: "#FFC97A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPage1);
export default __webpack_public_path__ + "static/media/Page-1.4dd6f02a7556a1f5bd15ba4a7ae85930.svg";
export { ForwardRef as ReactComponent };